import React from "react";
import {useTranslation} from "react-i18next";
import {Select} from "antd";
//local
import {Tag} from "components/Tag";
import {signContractStatusColor, signContractStatusKey} from "../constants";
import {IconChevronDown} from "components/icons";
import {color} from "constants/color.consts";
import cn from "classnames";

const SignContractStatusesSelect = ({
  list,
  multiple,
  onChange,
  disabled,
  defaultValue,
  selectedValue,
  addClass,
}) => {
  const {t} = useTranslation();
  const {Option} = Select;

  const options = () =>
    list?.map((status) => (
      <Option key={status} value={status}>
        <Tag
          text={status}
          color={signContractStatusColor[signContractStatusKey[status]]}
          suffixIcon={
            <IconChevronDown
              color={
                [
                  "SIGN_CONTRACT_STATUS_SELECT_STATUS",
                  "SIGN_CONTRACT_STATUS_SELECT_NO_STATUS",
                ].includes(status)
                  ? color[signContractStatusColor[signContractStatusKey[status]]]
                  : color.white
              }
            />
          }
          noBackground={
            (multiple && !selectedValue?.includes(status)) ||
            [
              "SIGN_CONTRACT_STATUS_SELECT_STATUS",
              "SIGN_CONTRACT_STATUS_SELECT_NO_STATUS",
            ].includes(status)
          }
          needTranslation
        />
      </Option>
    ));

  const tagRender = () => {
    const count =
      selectedValue?.length === list?.length ? "" : selectedValue?.length ?? "";
    return (
      <Tag
        text={`${count} ${t(
          count
            ? "SIGN_CONTRACT_STATUS_SELECT_STATUSES"
            : "SIGN_CONTRACT_STATUS_SELECT_NO_STATUS"
        )}`}
        suffixIcon={<IconChevronDown color={color.black} />}
        color={color.black}
        noBackground
      />
    );
  };

  return (
    <div className={cn("procurement-statuses-select_wrapper", {[addClass]: !!addClass})}>
      <Select
        className="procurement-statuses_select"
        bordered={false}
        tagRender={multiple ? tagRender : undefined}
        placeholder={
          multiple ? (
            <Tag
              text="PROJECT_ITEM_STATUS_NO_STATUS"
              suffixIcon={<IconChevronDown color={color.black} />}
              color={color.black}
              noBackground
              needTranslation
            />
          ) : undefined
        }
        showSearch={false}
        maxTagCount={1}
        onChange={onChange}
        mode={multiple ? "multiple" : undefined}
        suffixIcon={null}
        defaultValue={defaultValue}
        value={selectedValue}
        disabled={disabled}
        popupClassName="procurement-statuses_dropdown"
      >
        {options()}
      </Select>
    </div>
  );
};

export default SignContractStatusesSelect;
